import React, { Component, useEffect } from 'react';
import { connect } from 'react-redux';
import { withStyles } from "@material-ui/core";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ADDIcon from '@mui/icons-material/Add';
import Paper from '@mui/material/Paper';



const useStyles = (theme) => ({

    container: {
        height: '500',
    },

    item: {
        width: '30%',
        height: '500',
        padding: 24
    },

    divider: {
        height: '100vh',
        width: 1,
        backgroundColor: '#c5cae9'
    },

});



class ImportView_ extends Component {

    //constructor(props) {
    //    super(props);

    //    this.state = {
    //    };

    //}

    state = {
        stlPaths: [],
        materialTypes: [],
        sourceName: '',
    };

    componentDidMount() {
        this.fetchData();
    }

    fetchData = async () => {
        const response = await fetch('path/to/json/file.json');
        const data = await response.json();

        this.setState({
            stlPaths: data['STL-Paths'],
            materialTypes: data['Material-Types'],
            sourceName: data['Source-Name'],
        });
    }

    render() {

        const { classes } = this.props;
        const { stlPaths, materialTypes, sourceName } = this.state;

        return (

            <Grid
                container
                direction={'column'}
                alignItems="stretch"
                spacing={3}
                sx={{ ml: 10, mt: 3 }}
                justifyContent="flex-start"
                style={{ width: '90%' }}>

                {/*<Grid*/}
                {/*    container*/}
                {/*    direction={'row'}*/}
                {/*    alignItems="stretch"*/}
                {/*    spacing={3}*/}
                {/*    sx={{ ml: 10, mt: 3 }}*/}
                {/*    justifyContent="flex-start"*/}
                {/*    style={{ width: '90%' }} >*/}


                {/*    <Typography variant="h5" className={classes.title}>*/}
                {/*        Import Configuration*/}
                {/*    </Typography>*/}

                {/*    <input*/}
                {/*        accept=".json"*/}
                {/*        style={{ display: 'none' }}*/}
                {/*        id="contained-button-file"*/}
                {/*        multiple*/}
                {/*        type="file"*/}
                {/*        onChange={this.fetchData}*/}
                {/*    />*/}

                {/*    <label htmlFor="contained-button-file">*/}
                {/*        <Button variant="contained" color="primary" component="span" className={classes.button}>*/}
                {/*            Upload JSON*/}
                {/*        </Button>*/}
                {/*    </label>*/}

                {/*</Grid>*/}

                {/*<Grid*/}
                {/*    container*/}
                {/*    direction={'row'}*/}
                {/*    alignItems="stretch"*/}
                {/*    spacing={3}*/}
                {/*    sx={{ ml: 10, mt: 3 }}*/}
                {/*    justifyContent="flex-start"*/}
                {/*    style={{ width: '90%' }} >*/}


                {/*    <Box overflow="auto" sx={{ flexGrow: 1, maxHeight: '�80vh', marginTop: 3 }}>*/}

                {/*        <Paper*/}
                {/*            direction={'row'}*/}
                {/*            elevation={3}*/}
                {/*            className={classes.item} >*/}

                {/*            <Typography>STL File Path: <stlPaths /> </Typography>*/}

                {/*            <Typography>Material: <materialTypes /> </Typography>*/}

                {/*            <Typography>Source: <sourceName /> </Typography>*/}



                {/*        </Paper>*/}


                {/*    </Box>*/}


                {/*</Grid>*/}




            </Grid>

        );

    }
}




const mapStateToProps = (state, props) => {

    return {
    };

}

const mapDispatchToProps = (dispatch, props) => {

    return {
    };

}


const ImportView = connect(mapStateToProps, mapDispatchToProps)(ImportView_)
export default withStyles(useStyles)(ImportView);